import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../utils/api';
import { useAuth } from './AuthContext';

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const { user } = useAuth();
  const [cart,    setCart]    = useState({ items: [], total: 0, count: 0 });
  const [loading, setLoading] = useState(false);

  const fetchCart = useCallback(async () => {
    if (!user) { setCart({ items: [], total: 0, count: 0 }); return; }
    try {
      setLoading(true);
      const res = await api.get('/cart');
      setCart(res.data);
    } catch {}
    finally { setLoading(false); }
  }, [user]);

  useEffect(() => { fetchCart(); }, [fetchCart]);

  const addToCart  = async (product_id, qty = 1) => {
    try { await api.post('/cart', { product_id, qty }); fetchCart(); }
    catch (e) { console.error('addToCart:', e.message); throw e; }
  };
  const updateQty  = async (id, qty) => {
    if (qty < 1) { removeItem(id); return; }
    try { await api.put(`/cart/${id}`, { qty }); fetchCart(); }
    catch (e) { console.error('updateQty:', e.message); }
  };
  const removeItem = async (id) => {
    try { await api.delete(`/cart/${id}`); fetchCart(); }
    catch (e) { console.error('removeItem:', e.message); }
  };
  const clearCart  = async () => {
    try { await api.delete('/cart/clear'); fetchCart(); }
    catch (e) { console.error('clearCart:', e.message); }
  };

  return (
    <CartContext.Provider value={{ cart, loading, fetchCart, addToCart, updateQty, removeItem, clearCart }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
